<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

import ListDataEditor from '../content/ListDataEditor';
import ModelsList from './ModelsList'

export default {
  name: "DevicesPage",
  routes: [
    {
      path: "list/:id",
      component: ModelsList,
      name: "Devices models list",
      props: true,
      children: [
        {
          path: "data/new",
          components: {
            default: ModelsList,
            bottomEditor: ListDataEditor
          },
          props: {
            default: true,
            bottomEditor: true
          },
          name: "Device models new"
        },
        {
          path: "data/edit/:data_id",
          components: {
            default: ModelsList,
            bottomEditor: ListDataEditor
          },
          props: {
            default: true,
            bottomEditor: true
          },
          name: "Device models edit"
        }
      ]
    },

   
  ]
}
</script>